import script from "./contract-index.vue?vue&type=script&setup=true&lang=js"
export * from "./contract-index.vue?vue&type=script&setup=true&lang=js"

import "./contract-index.vue?vue&type=style&index=0&id=0be4b57d&lang=css"

const __exports__ = script;

export default __exports__